import { createContext, useContext } from 'react';

export type HeatmapMode = 'none' | 'maturity';

export const BcmHeatmapContext = createContext<HeatmapMode>('none');

export const useBcmHeatmap = () => useContext(BcmHeatmapContext);
